import React from 'react';
import classNames from 'classnames';

import { ImageService, EmptyPicture } from '@wix/members-area-commons-ts';
import { MediaPlatformImage } from '@wix/members-domain-ts';

import styles from './avatar.scss';
import { LAYOUT_PROFILE_IMAGE_ROUND } from '../../constants/avatar-layout-types';

interface AvatarProps {
  url: string | MediaPlatformImage;
  layoutType: number;
  className: string;
  dataHook: string;
  name: string;
  isMobile: boolean;
}

const isLayoutRound = (layoutType: number) => layoutType === LAYOUT_PROFILE_IMAGE_ROUND;

const DefaultPicture: React.StatelessComponent<{ layoutType: number }> = ({ children, layoutType }) => (
  <div className={classNames(styles.innerContainer, 'ma-avatar-bg')}>
    <div className={classNames(styles.innerContainer, 'ma-avatar-bg-overlay')}>
      <EmptyPicture className={classNames(styles.svg, 'ma-avatar-fill')} />
      <div
        className={classNames(styles.innerContainer, {
          [styles.round]: isLayoutRound(layoutType),
        })}
      />
      <div
        className={classNames(styles.innerContainer, 'ma-avatar-inner-border-overlay', {
          [styles.round]: isLayoutRound(layoutType),
        })}
      />
      {children}
    </div>
  </div>
);

const UserPicture: React.StatelessComponent<{
  url: string | MediaPlatformImage;
}> = ({ children, url }) => (
  <div
    className={classNames(styles.picture, styles.innerContainer)}
    style={{
      backgroundImage: `url(${new ImageService().getImageUrl({ image: url })})`,
    }}
  >
    {children}
  </div>
);

const Avatar: React.StatelessComponent<AvatarProps> = ({
  url,
  layoutType,
  children,
  className = '',
  dataHook,
  name,
  isMobile,
}) => (
  <div
    className={classNames(className, styles.container, {
      [styles.round]: isLayoutRound(layoutType),
    })}
    data-hook={dataHook}
  >
    {url ? (
      <UserPicture url={url}>{children}</UserPicture>
    ) : name ? (
      <div className={classNames(styles.nameLetter, isMobile && styles.isMobile)}>
        {name[0]}
        {children}
      </div>
    ) : (
      <DefaultPicture layoutType={layoutType}>{children}</DefaultPicture>
    )}
  </div>
);

export default Avatar;
